import React from 'react';
import { Text, Link } from '@fiverr-private/typography';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import { Stack, Grid, GridItem } from '@fiverr-private/layout_components';
import { TipsData } from '../../types';

interface TipsListProps {
  tips: TipsData;
  userClicked: () => void;
}

export const TipsList = ({ tips, userClicked }: TipsListProps) => (
  <Grid gap="6" templateColumns={{ default: '100%', sm: '50%_50%' }}>
    {tips.items.map(({ id, text, username, thumbnail, displayName, userLink }) => (
      <GridItem
        display="flex"
        direction="column"
        key={id}
        borderColor="grey_500"
        borderStyle="solid"
        borderWidth="sm"
        borderRadius="lg"
        paddingY="4"
        paddingX="6"
      >
        <Text flex="1" marginBottom="4" fontStyle="italic">
          {text}
        </Text>
        <Stack href={userLink}>
          <Avatar size="xs" username={username}>
            <AvatarImage alt="image-docs" src={thumbnail} />
          </Avatar>
          <Link
            href={userLink}
            onClick={userClicked}
            target="_blank"
            decoration={{ default: 'none', hover: 'underline' }}
            fontWeight="semibold"
          >
            {displayName || username}
          </Link>
        </Stack>
      </GridItem>
    ))}
  </Grid>
);
